export default "/calorie/food/@foodId";
